module.exports = __webpack_public_path__ + "img/comp_derek.55b9613d.png";